import type { JSX } from "react";
import type { Attribute } from "../sign-up-request";
import { TextField, type TextFieldProps } from "@mui/material";
import { useObservable } from "ecce-react";


type AttributeTextFieldProps = Omit<TextFieldProps, "onChange" | "value"> & {
	attribute: Attribute<string>;
};
export const AttributeTextField = (p: AttributeTextFieldProps): JSX.Element => {
	const { attribute, ...textFieldProps } = p;
	useObservable(attribute);

	return (
		<TextField
			value={ attribute.value }
			onChange={ attribute.handleChange }
			{ ...textFieldProps }
		/>
	);
};
